<template>
  <DabieWaterSystem />
</template>

<script setup>
import DabieWaterSystem from './App08大别山水系_完整版.vue';
</script>

<style>
html, body { margin: 0; padding: 0; width: 100%; height: 100%; overflow: hidden; background: #0a0e17; }
</style>
